
export const initialState = {
    userguide: {
        activeTab: "1",
        searchText: "",
        userguideList: [],        
    }
}